import type { Teasers } from '@generated/graphql';
import {
  getLocale,
  WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_WIDTH,
  WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_HEIGHT,
  QUERY_KEYS,
} from '@libs/constants';
import { nextApiCall } from '@libs/nextApiCall';
import { nextApiCallErrorFn } from '@libs/nextApiCallErrorFn';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { ToastType, useToasts } from '@hooks/useToasts';
import { useTranslation } from 'next-i18next';

export const useOnlineToolsTeaserQuery = () => {
  const router = useRouter();
  const locale = getLocale(router);
  const errMessage = 'Failed to fetch online tools teaser';
  const { t } = useTranslation(['layout/header', 'toast/toast']);
  const { addToast } = useToasts();

  return useQuery(
    [
      QUERY_KEYS.ONLINE_TOOLS_TEASER,
      'onlinetoolsteaser',
      locale,
      `${WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_WIDTH}x${WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_HEIGHT}`,
    ],
    async () => {
      const response = await nextApiCall('online-tools-teaser', {
        type: 'onlinetoolsteaser',
        locale,
        defaultImageSize: `${WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_WIDTH}x${WIDEN_DEFAULT_ONLINE_TOOLS_TEASERS_IMAGE_HEIGHT}`,
      });

      if (!response.ok) {
        throw new Error(errMessage);
      }

      return (await response.json()) as Teasers[];
    },
    {
      onError: err => {
        addToast({ content: t('TOAST.ERROR_OCCURRED', { ns: 'toast/toast' }), type: ToastType.ERROR });
        nextApiCallErrorFn(err, errMessage);
      },
    }
  );
};
